import React from 'react';
import { useTranslation } from 'react-i18next';

import { makeStyles } from '@material-ui/core/styles';

import { makeRowColumn, getHeadObj } from 'lib/commonLib';
import { timeAmtDetailStatistics } from 'lib/api/time';

import BasicModalHeader from 'components/molecules/Modal/Header';
import BasicModalSection from 'components/molecules/Modal/Section';
import BasicModalFooter from 'components/molecules/Modal/Footer';
import TableContainer from 'components/molecules/MbTable';
import InfoTitleArea from 'components/molecules/MbTable/InfoTitleArea';
import VariousCell from 'components/molecules/MbTable/VariousCell';
import BasicModal from 'components/organisms/Modal/Basic';

const useStyles = makeStyles((theme) => ({
  detailModal: {
    width: 1400,
  },
}));

const DetailModal = (props) => {
  const classes = useStyles();
  const { handleToggleModal, isOpen, params, time } = props;
  const { t } = useTranslation();

  let newParams = {
    ...params,
    statsHh: time,
    table: 'sub_table',
  };

  // header 및 body 컬럼 커스텀
  const customized = {
    ADVRTS_AMT: {
      makeHead: (headsMap) => {
        return `${getHeadObj(headsMap, 'ADVRTS_AMT').label}(쇼핑)`;
      },
      makeBody: (rowObj, headsMap) => {
        const advrtsAmt = getHeadObj(headsMap, 'ADVRTS_AMT');
        const trgtAdvrtsAmt = getHeadObj(headsMap, 'TRGT_ADVRTS_AMT');
        return (
          <>
            {makeRowColumn(
              rowObj['ADVRTS_AMT'],
              advrtsAmt.type,
              advrtsAmt.format
            )}
            (
            {makeRowColumn(
              rowObj['TRGT_ADVRTS_AMT'],
              trgtAdvrtsAmt.type,
              trgtAdvrtsAmt.format
            )}
            )
          </>
        );
      },
    },
    TRGT_ADVRTS_AMT: {
      merged: true,
    },
    CONV_RATE: {
      makeHead: (headsMap) => {
        return `${getHeadObj(headsMap, 'CONV_RATE').label}(전환수)`;
      },
      makeBody: (rowObj, headsMap) => {
        const orderCnt = getHeadObj(headsMap, 'ORDER_CNT');
        const convRate = getHeadObj(headsMap, 'CONV_RATE');
        return (
          <>
            {makeRowColumn(rowObj['CONV_RATE'], convRate.type, convRate.format)}{' '}
            (
            {makeRowColumn(rowObj['ORDER_CNT'], orderCnt.type, orderCnt.format)}
            )
          </>
        );
      },
    },
    ORDER_CNT: {
      merged: true,
    },
    CONV_AMT: {
      merged: true,
    },
    AVG_ORDER_AMT: {
      makeHead: (headsMap) => {
        return `${getHeadObj(headsMap, 'AVG_ORDER_AMT').label}(전환단가)`;
      },
      makeBody: (rowObj, headsMap) => {
        const avgOrderAmt = getHeadObj(headsMap, 'AVG_ORDER_AMT');
        const convAmt = getHeadObj(headsMap, 'CONV_AMT');
        return (
          <>
            {makeRowColumn(
              rowObj['AVG_ORDER_AMT'],
              avgOrderAmt.type,
              avgOrderAmt.format
            )}{' '}
            ({makeRowColumn(rowObj['CONV_AMT'], convAmt.type, convAmt.format)})
          </>
        );
      },
    },

    MOB_SESSION_ROAS: {
      makeHead: (headsMap) => {
        return {
          content: (
            <>
              <InfoTitleArea
                title={
                  getHeadObj(headsMap, 'MOB_SESSION_ROAS').label +
                  '(' +
                  t('쇼핑') +
                  ')'
                }
                tooltipType={'MOB_SESSION_ROAS'}
                iconType="fainfoCircle"
              />
            </>
          ),
          orderFlag: true,
        };
      },
      makeBody: (rowObj, headsMap) => {
        const mobSessionRoas = getHeadObj(headsMap, 'MOB_SESSION_ROAS');
        const trgtMobSessionRoas = getHeadObj(
          headsMap,
          'TRGT_MOB_SESSION_ROAS'
        );
        const mobSessionOrderAmt = getHeadObj(
          headsMap,
          'MOB_SESSION_ORDER_AMT'
        );
        return (
          <VariousCell
            type="TRGT"
            item1={makeRowColumn(
              rowObj['MOB_SESSION_ROAS'],
              mobSessionRoas.type,
              mobSessionRoas.format
            )}
            item2={makeRowColumn(
              rowObj['TRGT_MOB_SESSION_ROAS'],
              trgtMobSessionRoas.type,
              trgtMobSessionRoas.format
            )}
            item3={makeRowColumn(
              rowObj['MOB_SESSION_ORDER_AMT'],
              mobSessionOrderAmt.type,
              mobSessionOrderAmt.format
            )}
          />
        );
      },
    },
    TRGT_MOB_SESSION_ROAS: {
      merged: true,
    },
    MOB_SESSION_ORDER_AMT: {
      merged: true,
    },
    SESSION_ROAS: {
      makeHead: (headsMap) => {
        return {
          content: (
            <>
              <InfoTitleArea
                title={
                  getHeadObj(headsMap, 'SESSION_ORDER_AMT').label +
                  '(' +
                  t('쇼핑') +
                  ')'
                }
                tooltipType={'SESSION_ROAS'}
                iconType="fainfoCircle"
              />
            </>
          ),
          orderFlag: true,
        };
      },
      makeBody: (rowObj, headsMap) => {
        const sessionRoas = getHeadObj(headsMap, 'SESSION_ROAS');
        const trgtSessionRoas = getHeadObj(headsMap, 'TRGT_SESSION_ROAS');
        const sessionOrderAmt = getHeadObj(headsMap, 'SESSION_ORDER_AMT');
        return (
          <VariousCell
            type="TRGT"
            item1={makeRowColumn(
              rowObj['SESSION_ROAS'],
              sessionRoas.type,
              sessionRoas.format
            )}
            item2={makeRowColumn(
              rowObj['TRGT_SESSION_ROAS'],
              trgtSessionRoas.type,
              trgtSessionRoas.format
            )}
            item3={makeRowColumn(
              rowObj['SESSION_ORDER_AMT'],
              sessionOrderAmt.type,
              sessionOrderAmt.format
            )}
          />
        );
      },
    },
    TRGT_SESSION_ROAS: {
      merged: true,
    },
    SESSION_ORDER_AMT: {
      merged: true,
    },
    DIRECT_ROAS: {
      makeHead: (headsMap) => {
        return (
          <>
            <InfoTitleArea
              title={
                getHeadObj(headsMap, 'DIRECT_ORDER_AMT').label +
                '(' +
                t('쇼핑') +
                ')'
              }
              tooltipType={'DIRECT_ROAS'}
              iconType="fainfoCircle"
            />
          </>
        );
      },
      makeBody: (rowObj, headsMap) => {
        const directRoas = getHeadObj(headsMap, 'DIRECT_ROAS');
        const trgtDirectRoas = getHeadObj(headsMap, 'TRGT_DIRECT_ROAS');
        const directOrderAmt = getHeadObj(headsMap, 'DIRECT_ORDER_AMT');
        return (
          <VariousCell
            type="TRGT"
            item1={makeRowColumn(
              rowObj['DIRECT_ROAS'],
              directRoas.type,
              directRoas.format
            )}
            item2={makeRowColumn(
              rowObj['TRGT_DIRECT_ROAS'],
              trgtDirectRoas.type,
              trgtDirectRoas.format
            )}
            item3={makeRowColumn(
              rowObj['DIRECT_ORDER_AMT'],
              directOrderAmt.type,
              directOrderAmt.format
            )}
          />
        );
      },
    },
    TRGT_DIRECT_ROAS: {
      merged: true,
    },
    DIRECT_ORDER_AMT: {
      merged: true,
    },
    ROAS: {
      makeHead: (headsMap) => {
        return (
          <>
            <InfoTitleArea
              title={
                getHeadObj(headsMap, 'ORDER_AMT').label + '(' + t('쇼핑') + ')'
              }
              tooltipType={'ROAS'}
              iconType="fainfoCircle"
            />
          </>
        );
      },
      makeBody: (rowObj, headsMap) => {
        const roas = getHeadObj(headsMap, 'ROAS');
        const trgtRoas = getHeadObj(headsMap, 'TRGT_ROAS');
        const orderAmt = getHeadObj(headsMap, 'ORDER_AMT');
        return (
          <VariousCell
            type="TRGT"
            item1={makeRowColumn(rowObj['ROAS'], roas.type, roas.format)}
            item2={makeRowColumn(
              rowObj['TRGT_ROAS'],
              trgtRoas.type,
              trgtRoas.format
            )}
            item3={makeRowColumn(
              rowObj['ORDER_AMT'],
              orderAmt.type,
              orderAmt.format
            )}
          />
        );
      },
    },
    TRGT_ROAS: {
      merged: true,
    },
    CLICK_CNT: {
      makeHead: (headsMap) => {
        return `${getHeadObj(headsMap, 'CLICK_CNT').label}`;
      },
      makeBody: (rowObj, headsMap) => {
        const clickCnt = getHeadObj(headsMap, 'CLICK_CNT');
        let resultComponent;
        if (rowObj.isChild) {
          resultComponent = (
            <>
              {makeRowColumn(
                rowObj['CLICK_CNT'],
                clickCnt.type,
                clickCnt.format
              )}
            </>
          );
        } else {
          resultComponent = (
            <>
              {makeRowColumn(
                rowObj['CLICK_CNT'],
                clickCnt.type,
                clickCnt.format
              )}
            </>
          );
        }
        return resultComponent;
      },
    },
    ORDER_AMT: {
      merged: true,
    },
    ECPM: {
      makeHead: (headsMap) => {
        return (
          <>
            <InfoTitleArea
              title={getHeadObj(headsMap, 'ECPM').label + '(' + t('쇼핑') + ')'}
              tooltipType={'ECPM'}
              iconType="fainfoCircle"
            />
          </>
        );
      },
      makeBody: (rowObj, headsMap) => {
        const ecpm = getHeadObj(headsMap, 'ECPM');
        const trgtEcpm = getHeadObj(headsMap, 'TRGT_ECPM');
        return (
          <VariousCell
            type="TRGT"
            item1={makeRowColumn(rowObj['ECPM'], ecpm.type, ecpm.format)}
            item2={makeRowColumn(
              rowObj['TRGT_ECPM'],
              trgtEcpm.type,
              trgtEcpm.format
            )}
          />
        );
      },
    },
    TRGT_ECPM: {
      merged: true,
    },
  };

  const handleModalClose = () => {
    handleToggleModal(false, '');
  };

  return (
    <>
      <BasicModal open={isOpen}>
        <BasicModalHeader
          headerOpen={true}
          closeBtn
          closeOnClick={handleModalClose}
        ></BasicModalHeader>
        <BasicModalSection>
          <div className={classes.detailModal}>
            <>
              <TableContainer
                dataReqPromise={timeAmtDetailStatistics}
                params={{ ...newParams }}
                sort="desc"
                order="STATS_DTTM"
                dense={true}
                customized={customized}
                noneSearch
              />
            </>
          </div>
        </BasicModalSection>
        <BasicModalFooter
          confirmOnClick={true}
          cancelOnClick={handleModalClose}
          confirmBtnOpen={false}
          cancelBtnOpen={true}
          cancelBtnTitle={t('확인')}
        />
      </BasicModal>
    </>
  );
};
export default DetailModal;
